import {atom} from 'recoil';

export const failedMailAuthentication = atom({
  key: 'failedMailAuthentication',
  default: false,
});
